import { createContext, useContext } from 'react';
import type {
  ContactDetailsConfigContextValue,
  ContactDetailsContextData as ContextData,
  ContactDetailsDataContextValue,
  ContactDetailsStateContextValue,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useContactDetailsContext = () => useContext(context);

const stateContext = createContext<ContactDetailsStateContextValue>(
  {} as ContactDetailsStateContextValue
);
const configContext = createContext<ContactDetailsConfigContextValue>(
  {} as ContactDetailsConfigContextValue
);
const dataContext = createContext<ContactDetailsDataContextValue>(
  {} as ContactDetailsDataContextValue
);

export const ContactDetailsStateProvider = stateContext.Provider;
export const ContactDetailsConfigProvider = configContext.Provider;
export const ContactDetailsDataProvider = dataContext.Provider;

export const useContactDetailsState = () => useContext(stateContext);
export const useContactDetailsConfig = () => useContext(configContext);
export const useContactDetailsData = () => useContext(dataContext);
